module.exports = __webpack_public_path__ + "img/redesocial.6584c799.webp";